import { render, staticRenderFns } from "./generateJdShortLink.vue?vue&type=template&id=544253aa"
import script from "./generateJdShortLink.vue?vue&type=script&lang=js"
export * from "./generateJdShortLink.vue?vue&type=script&lang=js"
import style0 from "./generateJdShortLink.vue?vue&type=style&index=0&id=544253aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports